import { useEffect, useState } from "react";
import { Button, Col, Dropdown, Form, Modal, Row } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../axios/axios";
import { adminConfig } from "../../../utils/adminConfig";
import { message } from "antd";
import DataTable from "react-data-table-component";
import { ThreeDot } from "../../../assets/images";

export default function AddEscapeBucksProductCategory() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
  });
  const [allProductCategories, setAllProductCategories] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
    getAllProductCategories();
  }, []);

  const handleOnChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const addNewProduct = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(
        "/escape-bucks/product-categories",
        formData,
        adminConfig(),
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          setFormData({
            name: "",
          });
          getAllProductCategories();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const getAllProductCategories = () => {
    setLoading(true);
    axios
      .get("/escape-bucks/get-product-categories", adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setAllProductCategories(res.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  // const toggleStatus = (id) => {
  //   setLoading(true);
  //   axios
  //     .patch(
  //       `/escape-bucks/escape-bucks-product/toggle/${id}`,
  //       {},
  //       adminConfig(),
  //     )
  //     .then((res) => {
  //       setLoading(false);
  //       if (res.data.status) {
  //         message.success(res.data.message);
  //         getAllProductCategories();
  //       } else {
  //         message.error(res.data.message);
  //       }
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       console.error(err);
  //     });
  // };

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
    },

    {
      name: "Action",
      selector: (row) => (
        <Dropdown drop="down" className="select_box_preassigneds">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <img src={ThreeDot} alt="Action" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {/* <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                toggleStatus(row._id);
              }}
            >
              {row.status ? "Inactive" : "Active"}
            </div> */}
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                const { name, _id } = row;
                setFormData({
                  name,
                  id: _id,
                });
                setShowEditModal(true);
              }}
            >
              Edit
            </div>
          </Dropdown.Menu>
        </Dropdown>
      ),
      width: "90px",
    },
  ];

  const updateProduct = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .patch(
        "/escape-bucks/update-product-categories",
        formData,
        adminConfig(),
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          handleClose();
          getAllProductCategories();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const handleClose = () => {
    setShowEditModal(false);
    setFormData({
      name: "",
    });
  };

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <Modal show={showEditModal} centered>
        <Modal.Header>
          <Modal.Title>Update Product Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={updateProduct}>
            <Form.Group className="mb-3">
              <Form.Label>Product Category Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleOnChange}
                required
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-3">
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="mx-3" type="submit" variant="primary">
                Update
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <div className="cert_det_inner">
              <h2>Add Escape Credits Product Category</h2>
            </div>
            <Form onSubmit={addNewProduct}>
              <Row>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Product Category Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Product Category Name"
                      required
                      name="name"
                      value={formData.name}
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="sub_but mt-3">
                <button type="submit" className="add_but submit_buttt mt-0">
                  Submit
                </button>
              </div>
            </Form>
            <div className="cert_det_inner">
              <h2>Escape Credits Product Category Lists</h2>

              <DataTable
                columns={columns}
                data={allProductCategories}
                pagination
                striped
                responsive
                customStyles={customStyles}
                subHeaderAlign="right"
                subHeaderWrap
              />
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};
